module.exports = __webpack_public_path__ + "static/media/45_A.7f2a0cf9.png";